import AlertDisplay from "../ui/cmp/AlertDisplay";
import TransitionCollapse from "../ui/transition/TransitionCollapse";
import FormValidatorCtxBo from "./ctx-provider/FormValidatorCtxBo";
import useFormValidatorCtx from "./ctx-provider/useFormValidatorCtx";

const AlertFormError: React.FC = () => {

    // Hook wird verwendet, um Aenderungen mitzubekommen
    useFormValidatorCtx();

    return (
        <TransitionCollapse show={FormValidatorCtxBo.error === true}>
            <AlertDisplay severity='error'>
                Ihre Eingaben sind unvollständig.Bitte überprüfen Sie die rot markierten Eingabefelder.
                {process.env.NODE_ENV === 'development' && <>

                    <span style={{ display: 'block' }}>Development:</span>
                    {FormValidatorCtxBo.errorKeyList.map(id => <span key={id} style={{ display: 'block' }}>{id}</span>)}
                </>}
            </AlertDisplay>
        </TransitionCollapse>
    );

}

export default AlertFormError;